export default __webpack_public_path__ + "static/media/logo.d3c6befb.png";